<template>
  <div class="web-container" id="web-container">
    <main-header />
    <router-view></router-view>
    <sidebar :key="$route.path"/>
    <main-footer />
  </div>
</template>
<script>
import MainHeader from '../components/MainHeader'
import MainFooter from '../components/MainFooter'
import Sidebar from '../components/Sidebar'
export default {
  components: {
    MainHeader,
    MainFooter,
    Sidebar
  },
  async created () {
    await this.$store.dispatch('getPublicApiToken')
  }
}
</script>

<style lang="scss" scoped>

.web-container {
  padding-top: 4.5rem;
}
</style>
